export default __webpack_public_path__ + "static/media/dgv_handicap-regeln_2021.69a408c2.pdf";